import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { handleActions } from 'redux-actions';
import { markRoomRead, markRoomReadSyncDone, presenceJoin, presenceLeave, requestFocusOnMessage, scrollToRequestedMessage, selectRoom, setActiveRoomData, setTypingText, stopTyping } from '../actions/room';
export default handleActions({
    [`${selectRoom}`]: (state, action)=>_object_spread_props(_object_spread({}, state), {
            activeRoom: action.payload.room_id
        }),
    [`${setActiveRoomData}`]: (state, action)=>{
        var _state_activeRoom;
        return _object_spread_props(_object_spread({}, state), {
            prevActiveRoom: (_state_activeRoom = state.activeRoom) !== null && _state_activeRoom !== void 0 ? _state_activeRoom : undefined,
            activeRoomRow: action.payload.roomRow
        });
    },
    [`${markRoomRead}`]: (state, action)=>{
        var _state_markAsReadQueue;
        return _object_spread_props(_object_spread({}, state), {
            markAsReadQueue: [
                ...(_state_markAsReadQueue = state.markAsReadQueue) !== null && _state_markAsReadQueue !== void 0 ? _state_markAsReadQueue : [],
                action.payload.room_id
            ]
        });
    },
    [`${markRoomReadSyncDone}`]: (state, action)=>_object_spread_props(_object_spread({}, state), {
            markAsReadQueue: []
        }),
    [`${presenceJoin}`]: (state, action)=>{
        var _state_presence;
        const room_id = action.payload.room_id;
        const joiners = action.payload.joiners.reduce((acc, item)=>{
            acc[item.user_id] = item;
            return acc;
        }, {});
        var _state_presence1, _state_presence_room_id;
        return _object_spread_props(_object_spread({}, state), {
            presence: _object_spread_props(_object_spread({}, (_state_presence1 = state.presence) !== null && _state_presence1 !== void 0 ? _state_presence1 : {}), {
                [room_id]: _object_spread({}, (_state_presence_room_id = state === null || state === void 0 ? void 0 : (_state_presence = state.presence) === null || _state_presence === void 0 ? void 0 : _state_presence[room_id]) !== null && _state_presence_room_id !== void 0 ? _state_presence_room_id : {}, joiners)
            })
        });
    },
    [`${presenceLeave}`]: (state, action)=>{
        var _state_presence;
        const { room_id: roomId, leavers } = action.payload;
        const leftUserIds = leavers.map(({ user_id })=>user_id);
        var _state_presence_roomId;
        const roomPresence = (_state_presence_roomId = state === null || state === void 0 ? void 0 : (_state_presence = state.presence) === null || _state_presence === void 0 ? void 0 : _state_presence[roomId]) !== null && _state_presence_roomId !== void 0 ? _state_presence_roomId : {};
        const updatedPresence = Object.fromEntries(Object.entries(roomPresence).filter(([userId])=>!leftUserIds.includes(userId)));
        var _state_presence1;
        return _object_spread_props(_object_spread({}, state), {
            presence: _object_spread_props(_object_spread({}, (_state_presence1 = state.presence) !== null && _state_presence1 !== void 0 ? _state_presence1 : {}), {
                [roomId]: updatedPresence
            })
        });
    },
    [`${stopTyping}`]: (state, action)=>{
        return _object_spread_props(_object_spread({}, state), {
            typingText: undefined
        });
    },
    [`${setTypingText}`]: (state, action)=>{
        return _object_spread_props(_object_spread({}, state), {
            typingText: action.payload.text
        });
    },
    [`${requestFocusOnMessage}`]: (state, action)=>_object_spread_props(_object_spread({}, state), {
            focusMessageRequest: {
                messageId: action.payload.messageId,
                isReadyForScroll: false,
                shouldDropOtherMessages: false
            }
        }),
    [`${scrollToRequestedMessage}`]: (state, action)=>_object_spread_props(_object_spread({}, state), {
            focusMessageRequest: _object_spread_props(_object_spread({}, state.focusMessageRequest), {
                /**
         * Checking focusMessageRequest.messageId here to guard against dispatching this action directly instead of
         * through {@link requestFocusOnMessage}.
         */ isReadyForScroll: !!state.focusMessageRequest.messageId,
                shouldDropOtherMessages: !!state.focusMessageRequest.messageId && action.payload.shouldDropOtherMessages
            })
        })
}, {
    activeRoom: undefined,
    focusMessageRequest: {
        messageId: undefined,
        isReadyForScroll: false,
        shouldDropOtherMessages: false
    }
});

//# sourceMappingURL=room.js.map